import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

import { IStateRepair } from "@/apps/merchant3/models/IStateRepair";

export default {
  namespaced: true,
  state: {
    activationMethod: null,
    additionalContactEmail: null,
    additionalContactPhone: null,
    clientName: null,
    deviceFamilyId: null,
    deviceModelName: null,
    deviceTag: null,
    newDeviceModelName: null,
    phoneProblemDescription: null,
    status: null,
    statuses: [],
    repairType: null,
    samePhysicalDevice: true,
  } as IStateRepair,
  actions,
  mutations,
  getters,
};
